import {Component, Emit, Prop, Vue,Watch} from 'vue-property-decorator';
import moment from 'moment';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import EditModal from '@/assets/common/Modal/EditModal/EditModal.vue';
import SelectFromPlantings from '@/components/Record/SelectFromPlantings/SelectFromPlantings.vue';
import SelectFromAgriFields from '@/components/Record/SelectFromAgriFields/SelectFromAgriFields.vue'
import SelectFromWorkRecords from '@/components/Record/SelectFromWorkRecords/SelectFromWorkRecords.vue'
import RecordInfo from '@/components/Record/RecordInfo/RecordInfo.vue';
import { File, 
    RecordInfoModel, 
    HarvestShippingItem, 
    HarvestShipping, 
    SelectAgriFieldAndPlanting, 
    HarvestRecordData, 
    HarvestRecordItem ,
    Machine,
    Worker,
    WorkTimeState,
    Item} from '@/types/Component';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import SelectTime from '@/components/Record/WorkRecord/SelectTime/SelectTime.vue'
import SelectInterval from '@/components/Record/WorkRecord/SelectInterval/SelectInterval.vue'
import MachineSelectModal from '@/assets/common/Modal/ItemSelectModal/MachineSelectModal/MachineSelectModal.vue'
import WorkerSelectModal from '@/assets/common/Modal/ItemSelectModal/WorkerSelectModal/WorkerSelectModal.vue'
import WorkRecordModal from '@/assets/common/Modal/WorkRecordModal/WorkRecordModal.vue';

type WorkerPost = {
    worker_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    plan_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    actual_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    plan_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    actual_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    plan_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    actual_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    plan_work_time: number, // 作業時間
    actual_work_time: number, // 作業時間
    memo: string, // メモ
    kind: "SCHEDULE" | "ACTUAL";
}

type MachinePost = {
    machine_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    memo: string, // メモ
}

@Component({
    components: {
        Thumbnail,
        EditModal,
        SelectFromPlantings,
        SelectFromWorkRecords,
        SelectFromAgriFields,
        RecordInfo,
        SelectTime,
        SelectInterval,
        MachineSelectModal,
        WorkerSelectModal,
        WorkRecordModal
    }
})

export default class HarvestRecord extends Vue {
    
    @Prop({ default: false })
    private readonly isShow!: boolean;

    closeModal() {
        if (this.refresh) {
            this.$emit('update:isRefresh', true);
            this.refresh = false;
        }
        if(this.isHarvestOpen === 'true' && this.id == null || this.isHarvestOpen === 'true' && this.id != null ){
            this.$router.push(`/${this.$route.query.return_to}?date=${this.date}`).then(() => {return})
        }
        else{
            if (store.getters.isInputChanged) {
                const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
                if (confirm) {
                    store.dispatch("doUpdateIsInputChanged", false);
                    this.editTargetId=''
                    this.modeType =''
                    this.harvestRecordId=''
                    this.$emit('update:isShow', false);
               }
            }else{
                this.editTargetId=''
                this.modeType =''
                this.harvestRecordId=''
                this.$emit('update:isShow', false);
            }
        }
    }

    @Prop()
    private id?: string

    @Prop()
    private mode?: string

    @Prop({ default: false })
    private readonly isRefresh!: boolean;

    @Watch("isShow")
    handleHarvestRecordModal() {
            if(this.id) {
                this.editTargetId = this.id
                this.harvestRecordId = this.id
            } else {
                this.editTargetId = ''
            }
            if(this.mode) {
                this.modeType = this.mode
            }
            this.init()
    }
   
    private date = moment(new Date()).format('YYYY-MM-DD')
    private measurementTimingId = ''
    private measurementTimings: HarvestShippingItem[] = []
    private plantingAndAgriField: SelectAgriFieldAndPlanting = {
        agriField: {
            id: '',
            name: '',
            plantedArea: 0
        },
        planting: {
            id: '',
            name: '',
        }
    }
    private weightUnits: HarvestShippingItem[] = []
    private qualityStandards: HarvestShippingItem[] = []
    private harvestRecordData: HarvestRecordData[] = [
        {
            harvestRecordDataId :'',
            harvestRecordId:"",
            weightPerUnit:1,
            qualityStandardId: '',
            qualityStandardName: '',
            quantity: null,
            remainingQuantity:null,
            weightUnitId: null,
            weightUnitName: '',
            harvestLotNumber :'',
            qualityDisplayFlag: ''
        }
    ]
    private machines :Machine[] =[]
    private workers :Worker[] =[]
    private lotNumber = ''
    private existLotNumber = false
    private images: File[] = []
    private selectedImages: File[] = []
    private deletedImages: File[] = []
    private memo = ''
    private workRecordOption = ''
    workRecordOptionDef = '';
    private modalBaseUrl = ''
    private showEditModal = false
    private showSelectFromPlantings = false
    private showSelectFromAgriFields = false
    private isCopy = false
    private apiBaseUrl = '/harvest_records'
    private recordInfo: RecordInfoModel | null = null
    private isEditable = true
    deleteWorkersIdArr = [] as string []
    private workerInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private machineInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
    private targetSelectTime: WorkTimeState | null = null
    private showSelectTime = false;
    private showSelectInterval = false
    private selectTimeIndex: number | 'all' | undefined;
    private workerOrMachine: 'WORKER' | 'MACHINE' = 'WORKER'
    private showMachineSelect = false
    private showWorkerSelect = false
    private modeType =''
    private editTargetId =''
    private harvestRecordId =''
    private headerTitle = ''
    private subTitle = '';
    private workRecordId = ''
    private existingWorkRecordId = '';
    private plantingBasicUnitId:any =''
    private showWork = false
    private workMode: string | null = null;
    private refresh = false;
    private showSelectFromWorkRecords = false

    @Prop()
    private isHarvestOpen!: string
    @Prop()
    private harvestDate!: string

    private created() {
        this.handleHarvestRecordModal();
    }

    private init() {
        if(this.modeType == 'edit'){
            this.headerTitle = '収穫記録編集'
            this.getHarvestRecord(this.editTargetId);
        }
        else{
        this.headerTitle = '収穫記録新規作成'
        this.subTitle = this.modeType === 'copy' ? '（複製）': '';
        this.date = this.harvestDate ? this.harvestDate : moment(new Date()).format('YYYY-MM-DD')
        this.measurementTimingId = ''
        this.plantingAndAgriField = {
            agriField: {
                    id: '',
                    name: '',
                plantedArea: 0
                },
                planting: {
                    id: '',
                    name: '',
                }
            }
        this.harvestRecordData = [
                {
                    harvestRecordDataId:'',
                    harvestRecordId:"",
                    weightPerUnit:1,
                    qualityStandardId: '',
                    qualityStandardName: '',
                    quantity: null,
                    remainingQuantity:null,
                    weightUnitId: null,
                    weightUnitName: '',
                    harvestLotNumber:'',
                    qualityDisplayFlag:''
                }
            ]
        this.workRecordId = ''
        this.existingWorkRecordId = ''
        this.workers =[]
        this.machines =[]
        this.lotNumber = ''
        this.existLotNumber = false
        this.images = []
        this.selectedImages = []
        this.deletedImages = []
        this.memo = ''
        this.showEditModal = false
        this.showSelectFromPlantings = false
        this.showSelectFromAgriFields = false
        this.isCopy = false
        this.isEditable= true
        this.getMeasurementTiming()
        this.getQualityStandards()
        this.getWeightUnits()
        if (this.editTargetId) {
            this.getHarvestRecord(this.editTargetId)
        } else {
            this.getPreferredWorkOption()
        }
        }
    }

    private getHarvestRecord(id: string) {
        this.measurementTimingId = ''
        this.$apiClient.doRequest('get', '/harvest_records/' + id).then(ret => {
            this.existingWorkRecordId = ret.work_record_id;
            this.workRecordId = ret.work_record_id;
            const item = toCamel(ret) as HarvestRecordItem
            this.workRecordOption = item.workRecordOption
            this.workRecordOptionDef = item.workRecordOption
            if (this.modeType === "edit") {
                this.isEditable = item.isEditable
            } else {
                if (this.modeType === 'copy') {
                    this.workRecordId = '';
                }
                this.isEditable = true
            }
            const parent = this.$parent as any
            parent.isEditable = item.isEditable
            this.date = item.harvestDate
            this.plantingAndAgriField = {
                agriField: {
                    id: item.agriField?.id,
                    name: item.agriField?.name,
                    plantedArea: item.agriField?.plantedArea
                },
                planting: {
                    id: item.planting?.id,
                    name: item.planting?.name,
                }
            }
            this.plantingBasicUnitId =this.plantingAndAgriField.planting.id
            this.measurementTimingId = item.measurementTimingId
            const workerRecord : Worker[] = item.workers.map((item: any) => {
                return {
                    worker: {
                        id: item.worker.id, 
                        name: item.worker.name 
                    },
                    startWorktime: item.actualStartWorktime ,
                    planStartWorktime: item.planStartWorktime,
                    actualStartWorktime: item.actualStartWorktime,
                    endWorktime: item.actualEndWorktime,
                    planEndWorktime: item.planEndWorktime, 
                    actualEndWorktime: item.actualEndWorktime,
                    restTime:  item.actualRestTime,
                    planRestTime: item.planRestTime, 
                    actualRestTime: item.actualRestTime,
                    workTime:  item.actualWorkTime ,
                    planWorkTime: item.planWorkTime, 
                    actualWorkTime: item.actualWorkTime,
                    memo: item.memo,
                    kind: item.kind
                };
            });
            this.workers = workerRecord
            this.machines = item.machines
            this.harvestRecordData = item.harvestRecordData
            this.lotNumber = item.lotNumber
            this.memo = item.memo
            this.recordInfo = {
                createdUser: item.createdUser,
                created: item.created,
                updatedUser: item.updatedUser,
                updated: item.updated
            }
            this.getMeasurementTiming()
            this.getQualityStandards()
            this.getWeightUnits()
            this.getPlantingWeightUnitId()
            let workerInputTypeIsTimePoint
            if(this.workers.length) {
                workerInputTypeIsTimePoint = this.workers
                .map(w => 
                    w.actualStartWorktime !== null && w.actualEndWorktime !==null && w.actualRestTime!==null
                    ).reduce((res, b) => 
                    res && b
                    )
            }
            this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
            let machineInputTypeIsTimePoint
            if(this.machines.length) {
                machineInputTypeIsTimePoint = this.machines
                    .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                    .reduce((res, b) => res && b)
            }
            this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
            if(!this.isCopy && item.fileId.length > 0) {
                const promise: any = []
                item.fileId.forEach((id: string) => {
                    promise.push(this.$apiClient.doRequest('get', `/harvest_records/${this.harvestRecordId}/images/${id}`))
                })
                Promise.all(promise).then(ret => {
                    const file = toCamel(ret) as File[]
                    this.images = file
                })
            }
            else{
                this.images = []
            }
        })
    }

    private getMeasurementTiming() {
        this.$apiClient.doRequest('get', '/measurement_timings?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.measurementTimings = item.measurementTimings
        }).catch(() => {
            return
        })
    }

    private getQualityStandards() {
        this.$apiClient.doRequest('get', '/quality_standards?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.qualityStandards = item.qualityStandards
        }).catch(() => {
            return
        })
    }

    private getWeightUnits() {
        this.$apiClient.doRequest('get', '/weight_units?with_hidden=true').then(ret => {
            const item = toCamel(ret) as HarvestShipping
            this.weightUnits = item.weightUnits
        }).catch(() => {
            return
        })
    }

    private getPreferredWorkOption() {
        this.$apiClient.doRequest('get', `/graphScreenManagement/HARVESTRECORD`).then(ret => {
            this.workRecordOption = ret.workRecordOption;
        })
    }

    @Watch('workRecordOption')
    private async resetWorkData() {
        this.workers = []
        this.machines = []
        this.deleteWorkersIdArr = []
        this.workRecordId = ''
        if (this.mode == "edit" && ((this.workRecordOptionDef === 'WITHWORK' && this.workRecordOption === 'WITHWORK') || (this.workRecordOptionDef === 'LINKWORK' && this.workRecordOption === 'LINKWORK'))) {
            this.workRecordId = this.existingWorkRecordId
            if (this.existingWorkRecordId) {
                const res = await this.$apiClient.doRequest('get', '/work_records/' + this.existingWorkRecordId)
                this.commitWorkRecord(res);
            }
        } else if (this.mode == "copy" && this.workRecordOptionDef === 'WITHWORK' && this.workRecordOption === 'WITHWORK') {
            if (this.existingWorkRecordId) {
                const res = await this.$apiClient.doRequest('get', '/work_records/' + this.existingWorkRecordId)
                this.commitWorkRecord(res);
            }
        } 
    }

    private handleWorkRecordPopup() {
        const errmsg: string[] = [];
        if (!this.date) errmsg.push('日付を選択してください。');
        if (!this.plantingAndAgriField.agriField.id || !this.plantingAndAgriField.planting.id) {
            errmsg.push('作付・圃場を選択してください。');
        }
        if (errmsg.length > 0) {
            window.alert(errmsg.join('\n'));
            return false;
        }
        return this.showSelectFromWorkRecords = true;
    }

    private commitWorkRecord(workRecord: any) {
        this.workers = []
        this.machines = []
        this.deleteWorkersIdArr = []
        this.workRecordId = workRecord.id;
        const workerRecord : Worker[] = workRecord.workers.map((item: any) => {
            return {
                worker: {
                    id: item.worker.id, 
                    name: item.worker.name 
                },
                startWorktime: workRecord.kind === "SCHEDULE" ? item.plan_start_worktime : item.actual_start_worktime,
                planStartWorktime: item.plan_start_worktime,
                actualStartWorktime: item.actual_start_worktime,
                endWorktime: workRecord.kind === "SCHEDULE" ? item.plan_end_worktime : item.actual_end_worktime,
                planEndWorktime: item.plan_end_worktime, 
                actualEndWorktime: item.actual_end_worktime,
                restTime: workRecord.kind === "SCHEDULE" ? item.plan_rest_time : item.actual_rest_time,
                planRestTime: item.plan_rest_time, 
                actualRestTime: item.actual_rest_time,
                workTime: workRecord.kind === "SCHEDULE" ? item.plan_work_time : item.actual_work_time,
                planWorkTime: item.plan_work_time, 
                actualWorkTime: item.actual_work_time,
                memo: item.memo,
                kind: "ACTUAL"
            };
        });
        this.workers = workerRecord;
        let workerInputTypeIsTimePoint;
        if (this.workers.length) {
            workerInputTypeIsTimePoint = this.workers
            .map(w => workRecord.kind === "SCHEDULE" ?  w.planStartWorktime !== null && w.planEndWorktime !== null && w.planRestTime !== null : w.actualStartWorktime !== null && w.actualEndWorktime !== null && w.actualRestTime !== null)
            .reduce((res, b) => res && b)
        }
        this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
        const machineRecord : Machine[] = workRecord.machines.map((item: any) => {
            return {
                machine: {
                    id: item.machine.id, 
                    name: item.machine.name 
                },
                startWorktime: item.plan_start_worktime,
                endWorktime: item.end_worktime,
                restTime: item.rest_time,
                workTime: item.work_time,
                memo: item.memo,
            };
        });
        let machineInputTypeIsTimePoint;
        this.machines = machineRecord;
        if (this.machines.length) {
            machineInputTypeIsTimePoint = this.machines
                .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
                .reduce((res, b) => res && b)
        }
        this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
        this.showSelectFromWorkRecords = false
    }

    private updateItems(baseUrl: string) {
        switch (baseUrl) {
            case '/weight_units':
                this.getWeightUnits()
                break
            case '/measurement_timings':
                this.getMeasurementTiming()
                break
            case '/quality_standards':
                this.getQualityStandards()
                break
        }
    }

    private closeEditModal() {
        this.showEditModal = false
    }

    private commitPlantingAndField(item: SelectAgriFieldAndPlanting) {
        this.showSelectFromPlantings = false
        this.showSelectFromAgriFields = false
        this.plantingAndAgriField = {
            agriField: {
                id: item.agriField.id,
                name: item.agriField.name,
                plantedArea: item.agriField.plantedArea
            },
            planting: {
                id: item.planting?.id,
                name: item.planting?.name
            }
        }
        this.getPlantingWeightUnitId()
    }

    getPlantingWeightUnitId(){
        const plantingId =this.plantingAndAgriField.planting.id
        this.$apiClient.doRequest('get', `/plantings/${plantingId}`)
        .then((res)=>{
            this.plantingBasicUnitId =  res.basic_unit_id
            this.setDefaultWeightUnit()
        })
    }

    private editMeasurementTiming() {
        this.modalBaseUrl = '/measurement_timings'
        this.showEditModal = true
    }

    private editWeightUnits() {
        this.modalBaseUrl = '/weight_units'
        this.showEditModal = true
    }

    private editQualityStandards() {
        this.modalBaseUrl = '/quality_standards'
        this.showEditModal = true
    }

    private addHarvestRecordData() {
        this.harvestRecordData.push({
            harvestRecordDataId:'',
            harvestRecordId:"",
            weightPerUnit:1,
            qualityStandardId: '',
            qualityStandardName: '',
            quantity: null,
            remainingQuantity:null,
            weightUnitId: this.plantingBasicUnitId || null,
            weightUnitName: '',
            harvestLotNumber:'',
            qualityDisplayFlag:'true'
        })
    }

    private deleteHarvestRecordData(index: number) {
        this.harvestRecordData.splice(index, 1)
        this.inputChanged()
    }

    private deletePlantingAndAgriField() {
        this.plantingAndAgriField = {
            agriField: {
                id: '',
                name: '',
                plantedArea: 0
            },
            planting: {
                id: '',
                name: '',
            }
        }
        this.plantingBasicUnitId =null
        this.setDefaultWeightUnit();
        this.inputChanged()
    }

    setDefaultWeightUnit(){
        this.plantingBasicUnitId = this.weightUnits.find(wu => wu.id === this.plantingBasicUnitId  && wu.isHidden ===false)?.id ?? null;
       this.harvestRecordData.map(harvest =>{
            if (this.plantingBasicUnitId && !harvest.harvestRecordDataId) {
                harvest.weightUnitId = this.plantingBasicUnitId; 
            }
             else if(!this.plantingBasicUnitId && !harvest.harvestRecordDataId){
                harvest.weightUnitId = null;
            }
       })
    }

    // ロットナンバーの仕様見直しのためUIからコメントアウトされたためロジック側もコメントアウト
    // private checkLotNumber(e: any) {
    //     if(e.target.value){
    //         this.$apiClient.doRequest('get', '/harvest_records/lot_number/' + e.target.value).then(ret => {
    //             this.existLotNumber = true
    //         }).catch(error => {
    //             return
    //         })
    //     }
    // }

    private onFileChange(e: any) {
        const files = e.target.files || e.dataTransfer.files;

        if(this.$apiClient.isSizeOver(files)) {
            return
        }

        for (const file of files) {
            if (this.$apiClient.isImageFile(file.name)) {
                this.$apiClient.getBase64(file).then((image: any) => {
                    const item = {
                        file: image.file,
                        url: image.base64
                    } as File
                    this.images.push(item)
                }).catch(() => {
                    window.alert('画像ファイルが読み込めませんでした')
                })
            } else {
                window.alert('画像ファイルを選択してください')
            }
        }
        e.target.value = ''
    }

    private deleteImage(image: File, index: number) {
        this.images.splice(index, 1)
        if(image.id) {
            this.deletedImages.push(image)
        }
    }

    private validate() {
        const errmsg: string[] = []

        // 日付
        if(!this.date) {
            errmsg.push('日付を選択してください。')
        }

        // 計測タイミング
        if(!this.measurementTimingId) {
            errmsg.push('計測タイミングを選択してください。')
        }

        // 作付・圃場
        if(this.plantingAndAgriField.agriField.id == '' || this.plantingAndAgriField.planting.id == '') {
            errmsg.push('作付・圃場を選択してください。')
        }

        //作業記録内容
        if(this.workRecordOption == 'LINKWORK' && this.workRecordId == '') {
            errmsg.push('紐づける作業記録を選択してください。')
        }

        //収穫データ
        if(this.harvestRecordData.length == 0) {
            errmsg.push('収穫データを入力してください。')
        }else {
            let qualityStandardMessage = ''
            let quantityMessage = ''
            for(const item of this.harvestRecordData) {
                if(!item.qualityStandardId) {
                    qualityStandardMessage = '品質・規格を入力してください。'
                }
                if(item.quantity) {
                    const isMinus: boolean = /-/.test(item.quantity.toString())
                    const integer: string = item.quantity.toString().split('.')[0]
                    const decimal: string = item.quantity.toString().split('.')[1]
                    if(isMinus || integer.length > 7 || decimal && decimal.length > 2){
                        quantityMessage = '数量は0以上の整数部7桁小数部2桁までの数値を入力してください。'
                    }
                }else {
                    quantityMessage = '数量を入力してください。'
                }
            }
            if(qualityStandardMessage) errmsg.push(qualityStandardMessage)
            if(quantityMessage) errmsg.push(quantityMessage)
        }

        // メモ
        if(this.memo && this.memo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.memo.length}文字）`)
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        return true
    }

    private saveRecord() {
        if (this.workRecordOption == "WITHOUTWORK") {
            this.workers = []
            this.machines = []
            this.deleteWorkersIdArr = []
        }
        if(!this.validate()){
            return
        }
        const harvestRecordData = this.harvestRecordData.map(data => {
            return {
                harvest_record_data_id : data.harvestRecordDataId,
                quality_standard_id: data.qualityStandardId,
                quantity: data.quantity ? data.quantity : null,
                weight_unit_id: (!data.weightUnitId || data.weightUnitId === 'null') ? null : data.weightUnitId,
                harvest_lot_number : data.harvestLotNumber
            }
        })
        const params = {
            harvest_date: this.date,
            measurement_timing_id: this.measurementTimingId,
            planting_id: this.plantingAndAgriField.planting.id,
            agri_field_id: this.plantingAndAgriField.agriField.id,
            harvest_record_data: harvestRecordData,
            work_record_id :  this.workRecordId  ? this.workRecordId  :null,
            workers: this.workers.map(w => ({
                worker_id: w.worker.id,
                start_worktime: w.startWorktime,
                plan_start_worktime:  w.planStartWorktime ,
                actual_start_worktime:  w.startWorktime,
                end_worktime: w.endWorktime,
                plan_end_worktime: w.planEndWorktime,
                actual_end_worktime:  w.endWorktime,
                rest_time: w.restTime == null ? 0 : w.restTime,
                plan_rest_time: w.planRestTime == null ? 0 : w.planRestTime,
                actual_rest_time:  w.restTime == null ? 0 :  w.restTime,
                work_time: w.workTime,
                plan_work_time: w.planWorkTime,
                actual_work_time:  w.workTime,
                kind:  "ACTUAL",
                memo: w.memo,
            })),
            deletedWorkers:this.deleteWorkersIdArr,
            machines: this.machines.map(w => ({
                machine_id: w.machine.id,
                start_worktime: w.startWorktime,
                end_worktime: w.endWorktime,
                rest_time: w.restTime == null ? 0 : w.restTime,
                work_time: w.workTime,
                memo: w.memo,
            })),
            lot_number: '',
            memo: this.memo,
            workRecordOption: this.workRecordOption
        }
        console.log(params);
        const promise = []
        let message = '変更を保存しました。'
        if(this.modeType === 'edit') {
            if(!window.confirm("内容を上書きして保存します。よろしいですか。")) {
                return false
            }
            promise.push(this.$apiClient.doRequest("put", `${this.apiBaseUrl}/${this.harvestRecordId}`, params))
        }else {
            message = '保存しました。'
            promise.push(this.$apiClient.doRequest("post", this.apiBaseUrl, params))
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        Promise.all(promise).then((ret: any) => {
            const imageRequests: any = []
            const uploadImages = this.images.filter((file: File) => !file.id)
            uploadImages.forEach(image => {
                imageRequests.push(this.$apiClient.fileUpload(`${this.apiBaseUrl}/${ret[0].id}/images`, image.file))
            })
            this.deletedImages.forEach(image => {
                imageRequests.push(this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${ret[0].id}/images/${image.id}`))
            })
        
            Promise.all(imageRequests).then(ret => {
                this.$emit('update:isRefresh', true);
                this.$toasted.success(message)
                if(this.$route.query.return_to){
                    this.$router.push(`/${this.$route.query.return_to}?date=${this.date}`).then(() => {return})
                }else {
                    this.closeModal()
                    this.init()
                    if(this.harvestRecordId) {
                        this.getHarvestRecord(this.harvestRecordId)
                    }
                }
            })
        }).catch(() => {
            this.$toasted.error('保存に失敗しました。')
        })
    }

    private deleteRecord() {
        const confirm = window.confirm('削除しますか？')
        if(confirm && this.harvestRecordId) {
            this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${this.harvestRecordId}`).then(ret =>{
                this.$toasted.success('削除しました。')
                this.editTargetId=''
                this.modeType ='add'
                this.$emit('update:isRefresh', true);
                this.closeModal();
                this.init()
                if(this.$route.query.return_to){
                    this.$router.push('/' + this.$route.query.return_to).then(() => {return})
                }
            }).catch(() => {
                this.$toasted.error('削除に失敗しました。')
            })
        }else if(confirm && !this.harvestRecordId) {
            this.$toasted.error('収穫記録が存在しません。')
        }else {
            this.$toasted.success('削除がキャンセルされました。')
        }
    }

    private filterWeightUnitsByDetail(item: HarvestRecordData) {
        return this.weightUnits.filter(wu => item.weightUnitId == wu.id || wu.isHidden === false)
    }

    private changeUnit(item: HarvestRecordData) {
        const selectedUnit = this.weightUnits.find(wu => wu.id === item.weightUnitId && wu.weightPerUnit === null);
        if (selectedUnit) {
            window.alert(`単位「${selectedUnit.name}」の1単位あたりの重量を設定してください。`);
            item.weightUnitId = null;
        }
        this.inputChanged();
    }

    get filterMeasurementTimings() {
        return this.measurementTimings
          .filter(m => this.measurementTimingId == m.id || m.isHidden === false)
    }

    private filterQualityStandardsByDetail(item: HarvestRecordData) {
        return this.qualityStandards
          .filter(qs => item.qualityStandardId == qs.id || qs.isHidden === false)
    }

    @Emit('inputChanged')
    private inputChanged(){
        if(store.getters.isInputChanged==false){
        this.$store.dispatch('doUpdateIsInputChanged', true);
        }
    }

    cancelRecord() {
        if (this.$store.getters.isInputChanged) {
            const result = window.confirm('変更内容を破棄します。よろしいですか。');
            if (!result) {
                return false;
            }
        }
        this.$store.dispatch('doUpdateIsInputChanged', false);
        if (this.harvestRecordId !== undefined && this.harvestRecordId !== '') {
            this.init()
            this.getHarvestRecord(this.harvestRecordId);
        } else {
            this.init()
        }
    }

    deleteWorker(index: number,workerId:string): void {
        this.deleteWorkersIdArr.push(workerId);
        this.workers.splice(index, 1)
        this.inputChanged()
    }

    deleteMachine(index: number): void {
        this.machines.splice(index, 1)
        this.inputChanged()
    }

    private initializeMachines(machines: Machine[]) {
        return machines.map(m => ({
            ...m.machine,
            isHidden: false,
        }))
    }

    private initializeWokers(workers: Worker[]) {
        return workers.map(w => ({
            ...w.worker,
            isHidden: false,
        }))
    }

    private openWorkerSelectTime(idx: number | 'all') {
        const isTime = this.workerInputType === 'TIME_POINT'
        if (isTime) {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const worker = this.workers[idx]
            // 既に作業時間（時刻の時は＋開始・終了時間）が入っているときはそれを初期値とする
            if(worker.workTime > 0 && (!isTime || (worker.startWorktime && worker.endWorktime))) {
                this.targetSelectTime = {
                    startWorktime: worker.startWorktime,
                    endWorktime: worker.endWorktime,
                    restTime: worker.restTime,
                    workTime: worker.workTime,
                }
            }
        }
        this.workerOrMachine = 'WORKER'
        this.inputChanged()
    }

    private openMachineSelectTime(idx: number | 'all') {
        if (this.machineInputType === 'TIME_POINT') {
            this.showSelectTime = true
        } else {
            this.showSelectInterval = true
        }
        this.selectTimeIndex = idx
        if(typeof idx === 'number') {
            const machine = this.machines[idx]
            // 既に作業時間が入っているときはそれを初期値とする
            if(machine.workTime > 0) {
                this.targetSelectTime = {
                    startWorktime: machine.startWorktime,
                    endWorktime: machine.endWorktime,
                    restTime: machine.restTime,
                    workTime: machine.workTime
                } as WorkTimeState
            }
        }
        this.workerOrMachine = 'MACHINE'
        this.inputChanged()
    }

    private commitTime(value: WorkTimeState) {
        if (this.workerOrMachine === 'WORKER') {
            if (typeof this.selectTimeIndex === 'number') {
                const worker = this.workers[this.selectTimeIndex]
                this.workers[this.selectTimeIndex] = { ...worker, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.workers = this.workers.map(w => ({ ...w, ...value }))
            }
        } else if (this.workerOrMachine === 'MACHINE') {
            if (typeof this.selectTimeIndex === 'number') {
                const machine = this.machines[this.selectTimeIndex]
                this.machines[this.selectTimeIndex] = { ...machine, ...value }
            } else if (this.selectTimeIndex === 'all') {
                this.machines = this.machines.map(m => ({ ...m, ...value }))
            }
        }
        this.targetSelectTime = value
    }

    private commitWorkers(value: { id: string, name: string }[]) {
        const existingWorker = this.workers.filter(w => value.find(v => v.id === w.worker.id) !== undefined)
        const newWorker: Worker[] = value
            .filter(v => this.workers.find(w => w.worker.id === v.id) === undefined)
            .map(v => ({
                worker: v,
                startWorktime: null,
                planStartWorktime: null,
                actualStartWorktime: null,
                endWorktime: null,
                planEndWorktime: null,
                actualEndWorktime: null,
                restTime: null,
                planRestTime: null,
                actualRestTime: null,
                workTime: 0,
                planWorkTime: 0,
                actualWorkTime: 0,
                memo: "",
                kind :"SCHEDULE"
            }))
        this.workers = [...existingWorker, ...newWorker]
    }

    private commitMachines(value: { id: string, name: string }[]) {
        const newMachines: Machine[] = value.map(v => {
            const existingMachine = this.machines.find(m => m.machine.id === v.id)
            return {
                machine: v,
                startWorktime: existingMachine ? existingMachine.startWorktime : null,
                endWorktime: existingMachine ? existingMachine.endWorktime : null,
                restTime: existingMachine ? existingMachine.restTime : null,
                workTime: existingMachine ? existingMachine.workTime : 0,
                memo: existingMachine ? existingMachine.memo : ""
            }
        })
        this.machines = [...newMachines]
    }

    private updateMachine(value: Item) {
        this.machines.forEach(item => {
            if (value && item.machine.id === value.id) {
                item.machine = value
            }
        })
    }

    private displayTime(time: string | null) {
        return time ? time.slice(0, 5) : ''
    }

    private minuteToHour(minute: number) {
        return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '0時間0分';
    }
    
    openWorkRecordModal() {
        this.workMode = "edit";
        this.showWork = true;
    }
      
    closeWorkRecordModal() {
        this.workMode = null;
        this.showWork = false;
    }
      
    refreshHarvest () {
        this.refresh = true;
        this.getHarvestRecord(this.harvestRecordId);
    }
}